import { Component, Input, OnInit, inject } from '@angular/core';
import Thumbnail from '../../interfaces/Thumbnail';
import { FavouritesService } from '../../services/favourites.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.scss'],
    imports: [RouterLink]
})
export class SearchResultComponent implements OnInit {
  favouritesService = inject(FavouritesService);


  @Input() product: Thumbnail;
  @Input() index: number;

  ngOnInit(): void {
    this.favouritesService.load();
  }

  addToFavourites(): void {
    this.favouritesService.add(this.product.code);
  }

  removeFromFavourites(): void {
    this.favouritesService.remove(this.product.code);
  }
}
